<template>
  <router-view />
</template>
<script>
import { onMounted } from 'vue';
import { useSetting } from './store/pinia'

export default {
  name: 'App',
  computed: {
    applicationStaticConfig () {
      return { ...this.$store.getters["AppicationStaticConfig/getApplicationStaticConfig"] }
    }
  },
  //TO BE USED FOR LAODING CSS DYNAMICALLY BASED ON CONDITIONS
  created () {
    import(`./assets_gide/css/${this.applicationStaticConfig.style_file}`).then(() => {
      // This .then() satisfies ESLint that the promise is being handled,
      // even if you don't do anything with the result.
      // For CSS, there's usually no module export to use here anyway.
    })
    .catch(error => {
      console.error("Failed to load style.scss:", error)
    })
  },
  setup(){
    const store = useSetting()
    onMounted(()=>{
      store.setSetting()
      let domainName = window.location.hostname

      let site_name = ""
      let site_description = ""

      if (domainName.includes("cuetpractice")) {
        site_name = "CUET Practice"
        site_description = "CUET Practice: Exam Ready Practice & Mock Tests"
      }
      else if (domainName.includes("clatperfect")) {
        site_name = "CLAT Perfect"
        site_description = "Master the CLAT, Perfectly"
      }
      else if (domainName.includes("gide")) {
        site_name = "GIDE Testseries"
        site_description = "Master SAT/AP with GIDE Testseries"
      }
      let site_favicon_prefix = site_name.replace(/\s+/g, "").toLowerCase()
      let site_logo = `https://gide-assets.s3.amazonaws.com/${site_favicon_prefix}.png`

      document.title = site_name
      document.querySelector('meta[name="twitter:site"]').setAttribute('content', site_name)
      document.querySelector('meta[name="twitter:card"]').setAttribute('content', site_description)
      document.querySelector('meta[name="twitter:title"]').setAttribute('content', site_name)
      document.querySelector('meta[name="twitter:description"]').setAttribute('content', site_description)
      document.querySelector('meta[name="twitter:image:src"]').setAttribute('content', site_logo)

      document.querySelector('meta[property="og:site_name"]').setAttribute('content', site_name)
      document.querySelector('meta[property="og:title"]').setAttribute('content', site_name)
      document.querySelector('meta[property="og:description"]').setAttribute('content', site_description)
      document.querySelector('meta[property="og:image"]').setAttribute('content', site_logo)

      document.querySelector('link[rel="icon"][sizes="32x32"]').setAttribute('href', `/${site_favicon_prefix}-favicon-32x32.png`)
      document.querySelector('link[rel="icon"][sizes="16x16"]').setAttribute('href', `/${site_favicon_prefix}-favicon-16x16.png`)
    })
  }
}
</script>

<style lang="scss">
@import "./assets/scss/customizer.scss";
@import "./assets/scss/custom.scss";
@import url("./plugins/Leaflet/leaflet.css");
@import url("./plugins/fullcalendar/core/main.css");
@import url("./plugins/fullcalendar/daygrid/main.css");
@import url("./plugins/fullcalendar/timegrid/main.css");
@import url("./plugins/fullcalendar/list/main.css");
</style>
